<template>
  <div>
    <h2>Вывоз отходов</h2>
    <el-date-picker
      v-model="date"
      type="dates"
      :clearable="false"
      :picker-options="pickerOptions"
      placeholder="Выберите дату"
      format="dd-MM-yyyy"
      value-format="yyyy-MM-dd"
      class="startTimeBox"
      @change="changeData"
    ></el-date-picker>
    
    <el-row v-for="dt in formattedDates" v-bind:key="dt" style="margin: 5px">
      {{dt}}
    </el-row>
    <el-divider></el-divider>

    <el-button type="primary" @click="openAddWasteModal" :disabled="block||date == ''"
      >Добавить отход</el-button
    >
    <el-divider></el-divider>
    <el-table stripe :data="wastes">
      <el-table-column
        label="Наименование отхода"
        prop="wasteName"
      ></el-table-column>
      <el-table-column label="Код отхода" prop="wasteCode"></el-table-column>
      <el-table-column
        label="Степень опасности"
        prop="dangerDegreeClassifierDTO.name"
      ></el-table-column>
      <el-table-column>
        <template slot-scope="item">
          <el-button
            @click="dropLine(item.$index)"
            type="primary"
            style="float: left"
            >Удалить
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider>

    <el-tree
      :data="data"
      show-checkbox
      node-key="id"
      ref="tree"
      :props="defaultProps"
      style="font-weight: bold"
    >
    </el-tree>
    <el-divider></el-divider>
    <el-button
      type="primary"
      @click="showData"
      :disabled="block||
        GETISDATEENTRYLOCKED(date != '' ? date[date.length - 1] : null)
      "
      >Отобразить данные</el-button
    >

    <custom-modal
      @addWasteToTable="addWasteToTable"
      title="Добавить отход"
      :visible="showModal === 'disposalAddWaste'"
    >
      <disposal-add-waste-form :action="date"></disposal-add-waste-form>
    </custom-modal>
  </div>
</template>

<script>
import CustomModal from "@/components/customModal";
import { mapGetters } from "vuex";
import DisposalAddWasteForm from "@/components/ecologist/disposal/disposalAddWasteForm";
import Cookies from "js-cookie";
export default {
  name: "disposalMain",
  components: { DisposalAddWasteForm, CustomModal },
  data() {
    return {
      block:false,
      userId: Cookies.get("userId"),
      pickerOptions:{
        firstDayOfWeek: 1
      },
      date: "",
      resp: [],
      wastes: [],
      addedWastes: [],
      data: [
        {
          id: 1,
          name: "Предприятие",
          children: [],
        },
      ],
      defaultProps: {
        children: "children",
        label: "name",
      },
    };
  },

  computed: {
    ...mapGetters({
      showModal: "GETSHOWMODAL",
      GETISDATEENTRYLOCKED: "GETISDATEENTRYLOCKED",
    }),
    formattedDates() {

      if(!this.date || this.date.length == 0){
        return []
      }

      return this.date.map(dt =>{
        const parts = dt.split("-")
        return parts[2] + "." + parts[1] + "." + parts[0]
      })
    }
  },

  methods: {
    dropLine(index) {
      this.wastes.splice(index, 1);
      this.getWasteOrgs();
    },
    async addWasteToTable(waste) {
      this.wastes.push(waste);
      this.getWasteOrgs();
    },
    async getWasteOrgs() {
      this.data = [{ id: 1, name: "Предприятие", children: [] }];
      this.wastes.forEach(async (waste) => {
        let t = 0;
        await this.getUnitList(4, waste.ss01DictionaryId).then((response) => {
          response.data.forEach((value1) => {
            t = 0;
            this.data[0].children.forEach((value2) => {
              if (value2.id == value1.id) {
                t = -1;
              }
            });
            if (t == 0) this.data[0].children.push(value1);
          });
          waste.orgs = response.data;
        });
      });
      /*console.log(this.wastes);*/
    },
    async changeData() {
      await this.$store.dispatch("getBlockForUser",this.date[this.date.length - 1]).then((response) => {
        if(response.data == true)
          {
            this.block=true;
            this.message(
              "Внимание! Заблокировано главным экологом!",
              "error",
              true
            );
            return;
          }
      this.block=false;
      console.log(this.date);

      if(!this.date || this.date.length == 0) {
        this.wastes = []; 
        return;
      }

      if (this.GETISDATEENTRYLOCKED(this.date[this.date.length - 1]))
        this.message(
          "Внимание! Внесение данных за " +
            new Date(this.date[this.date.length - 1]).getFullYear() +
            " год ограничено. Закрыт отчетный период",
          "error",
          true
        );
      //console.log("changeData");
      this.wastes = [];
      this.data = [
        {
          id: 1,
          name: "Предприятие",
          children: [],
        },
      ];
      
      });
    },
    openAddWasteModal() {
      this.$store.dispatch("setShowModal", "disposalAddWaste");
    },

    showData() {
      this.$router.push({
        path: "selected-waste",
        query: {
          wastes: this.wastes,
          chekbranches: this.$refs.tree.getCheckedNodes(),
          date: this.date,
        },
      });
    },

    async getUnitList(unitType, unitId) {
      return await this.$store.dispatch("organizationUnitsForSelectDatalimit", {
        unitType: unitType,
        unitId: unitId,
        unitdate: this.date[this.date.length - 1],
      });
    },
  },

  mounted() { },
};
</script>

<style scoped></style>
